import { C as writable } from "./server.js";
import "./index-server2.js";
//#region src/lib/plot.svelte.ts
var Plot = class {
	id;
	price;
	plantedTrees;
	constructor(id, price, plantedTrees) {
		this.id = id;
		this.price = price;
		this.plantedTrees = plantedTrees;
	}
};
var shoppingList = writable([]);
//#endregion
export { Plot as n, shoppingList as t };
